export enum EDestinoBanner {
    MesmaPagina = 1,
    NovaAba = 2,
}
